module.exports = __webpack_public_path__ + "img/uploadLogo.5db82f80.png";